import english from './moment.en.json';
import french from './moment.fr.json';
import spanish from './moment.es.json';
import italian from './moment.it.json';

export const en = english;
export const es = spanish;
export const fr = french;
export const it = italian;



// WEBPACK FOOTER //
// ./src/locales/moment-overrides.js